import { z } from 'zod';

import { ZodB2bSavingPlanCategory } from '@Common/types/b2b/plans';
import { BoListQueryBase } from '@Common/types/bo/bo_list_query';
import { buildZodBoListQueryParsed } from '@Common/types/bo/utils/build_zod_bo_list_query';
import { ZodDate } from '@Common/types/date';
import { ZodId } from '@Common/types/request';
import { createZodArrayable } from '@Common/types/zod/zod-arrayable';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const B2bOperationErNatureValues = ['MV', 'AN', 'IM'] as const;
export const ZodB2bOperationErNature = z.enum(B2bOperationErNatureValues);
export type B2bOperationErNature = z.TypeOf<typeof ZodB2bOperationErNature>;

export const B2bOperationErTypeValues = [
  'ABONDEMENT',
  'ABONDEMENT_COLL',
  'ABONDEMENT_DES',
  'ABONDEMENT_INV',
  'AFF_ABONDE',
  'AFF_COT',
  'AFF_COT_E',
  'AFF_COT_EXO',
  'AFF_COT_RATT',
  'AFF_COT_RATT_E',
  'AFF_COT_RATT_S',
  'AFF_COT_S',
  'AFF_INTERESS',
  'AFF_PARTICIP',
  'AFF_PPV',
  'AFF_PPVE',
  'AFF_VERS_CET',
  'ARB',
  'ARB_ATT',
  'ARB_ATT_DES',
  'ARB_ATT_EST_DES',
  'ARB_ATT_EST_INV',
  'ARB_ATT_INV',
  'ARB_AU_DES',
  'ARB_AU_INV',
  'ARB_CATT_DES',
  'ARB_CATT_INV',
  'ARB_CO',
  'ARB_CO_DES',
  'ARB_CO_INV',
  'ARB_COM',
  'ARB_COM_DES',
  'ARB_COM_INV',
  'ARB_DES',
  'ARB_INV',
  'ARB_PSAP_DES',
  'ARB_PSAP_INV',
  'ARB_REBAL_DES',
  'ARB_REBAL_INV',
  'ARB_SECU_DES',
  'ARB_SECU_INV',
  'AVANCE_FDS_RLMT',
  'CC_REVALO',
  'CC_REVALO_39',
  'COM_FDS_COLL',
  'COTI_ANTIC',
  'COTI_EXCEP',
  'COTI_RATT',
  'COTI_RATT_E',
  'COTI_RATT_S',
  'COTI_REGUL',
  'COTIS',
  'COTIS_DES',
  'COTIS_E',
  'COTIS_ESTIM',
  'COTIS_ESTIM_N',
  'COTIS_EXO',
  'COTIS_EXO_INV',
  'COTIS_INV',
  'COTIS_S',
  'D_TR_E_C_E',
  'D_TR_E_C_E_DES',
  'D_TR_E_C_E_INV',
  'D_TR_E_C_I',
  'D_TR_E_C_I_DES',
  'D_TR_E_C_I_INV',
  'D_TR_S_C_E',
  'D_TR_S_C_I',
  'DC_ACTIF_39',
  'DECES_ACTIF',
  'DC_PREST',
  'DC_REGL',
  'FISCALITE',
  'FR_CPT_ENT',
  'FR_CPT_SOUS',
  'FR_DC_EU',
  'FR_DC_UC',
  'FR_ENC_MIN',
  'FR_EU',
  'FR_EU_COMPL',
  'FR_EU_REDUC',
  'FR_FCL',
  'FR_GAR_PLAN',
  'FR_PRIME',
  'FR_REDUC',
  'FR_RENTE',
  'FR_TABLE_EU',
  'FR_TABLE_UC',
  'FR_UC',
  'FR_UC_COMPL',
  'INTERESS_DES',
  'INTERESS_EXCEPT',
  'INTERESS_INV',
  'INTERESS_REGUL',
  'INTERESSEMENT',
  'NANTISSEMENT',
  'OST_DDC',
  'OST_FA_DES',
  'OST_FA_INV',
  'PAR',
  'PARTICIP_DES',
  'PARTICIP_EXCEPT',
  'PARTICIP_INV',
  'PARTICIP_REGUL',
  'PARTICIPATION',
  'PB',
  'PB_FDS_RENTE',
  'PB_GAR_CAPITAL',
  'PERT_TECH_39',
  'PM_AJUST',
  'PPV',
  'PPV_DES',
  'PPV_E',
  'PPV_INV',
  'PPVE_DES',
  'PPVE_INV',
  'PRA',
  'PREST_39',
  'PREST_CC',
  'PREST_FILLON',
  'PREST_IFC',
  'PREST_IL',
  'PRLV_FISC',
  'PRLV_FISC_OBLIG',
  'PRLV_SOC',
  'PRST_CHARGE_SOC',
  'PRST_EXECEPTION',
  'PSAP',
  'PSAP_EA',
  'PSAP_PREST',
  'PVP',
  'RB_PRLV_SOC',
  'RBT_CARENCE_39',
  'RBT_CARENCE',
  'REG_ACTIF',
  'REG_PASSIF',
  'REGLE_COM_ENC',
  'REGLE_COM_MVT',
  'REMB_FDS_RLMT',
  'REX',
  'RP',
  'RPP',
  'RT',
  'SOR_CAPITAL',
  'SOR_CAPITAL_ENT',
  'SOR_RENTE',
  'SOR_RENTE_ENT',
  'SOR_RENTE_UNIQ',
  'T_PEP',
  'TMG',
  'TR_E_C_I_STOCK',
  'TR_ENT_C_E',
  'TR_ENT_C_I',
  'TR_ENT_C_RENTE',
  'TR_ENT_E',
  'TR_ENT_I',
  'TR_ENT_I_STOCK',
  'TR_ENTR_EXC_REV',
  'TR_ENTR_REVALO',
  'TR_SOR',
  'TR_SOR_C_E',
  'TR_SOR_C_I',
  'TR_SOR_C_P_E',
  'TR_SOR_C_P_I',
  'TR_SOR_E',
  'TR_SOR_I',
  'TR_SOR_PAR_C_E',
  'TR_SOR_PAR_C_I',
  'TR_SORT_REVALO',
  'TR_TECHNIQUE',
  'V1',
  'VERS_CET',
  'VERS_CET_DES',
  'VERS_CET_INV',
  'VERS_CET_REGUL',
  'VL',
  'VL_ENT',
  'VL_GRA',
  'VP',
  'VP_ENT',
] as const;
export const ZodB2bOperationErType = z.enum(B2bOperationErTypeValues);
export type B2bOperationErType = z.TypeOf<typeof ZodB2bOperationErType>;

const ZodGetB2bOperationErOneResponse = z.object({
  id: ZodId,
  operation_nature: ZodB2bOperationErNature,
  operation_type: ZodB2bOperationErType,
  amount_gross: z.number().nullable(),
  amount_net: z.number().nullable(),
  products: z.array(ZodB2bSavingPlanCategory),
  employee_count: z.number().nullable(),
  reference_period_start_date: ZodDate,
  reference_period_end_date: ZodDate,
  processing_date: ZodDate.nullable(),
});
export type GetB2bOperationErOneResponse = z.infer<typeof ZodGetB2bOperationErOneResponse>;

export const ZodGetB2bOperationsErResponse = z.array(ZodGetB2bOperationErOneResponse);
export type GetB2bOperationsErResponse = z.TypeOf<typeof ZodGetB2bOperationsErResponse>;

export const getB2bOperationsErSortColumns: (keyof GetB2bOperationsErResponse[number])[] = [
  'id',
  'operation_nature',
  'operation_type',
  'amount_gross',
  'amount_net',
  'reference_period_start_date',
  'processing_date',
];

const ZodB2bOperationsErFilters = z
  .object({
    id: createZodArrayable(ZodId),
    operation_nature: createZodArrayable(ZodB2bOperationErNature),
    operation_type: createZodArrayable(ZodB2bOperationErType),
    taiga_contract_id: createZodArrayable(ZodId),
    from_reference_period_start_date: ZodTrimmedString,
    to_reference_period_end_date: ZodTrimmedString,
    from_processing_date: ZodTrimmedString,
    to_processing_date: ZodTrimmedString,
  })
  .partial();
export type B2bOperationsErFilters = z.TypeOf<typeof ZodB2bOperationsErFilters>;

export const ZodGetB2bOperationsErQuery = buildZodBoListQueryParsed(
  ZodB2bOperationsErFilters,
  getB2bOperationsErSortColumns,
  {
    range: [0, 100],
  },
);

export type GetB2bOperationsErQuery = BoListQueryBase<
  z.TypeOf<typeof ZodB2bOperationsErFilters>,
  (typeof getB2bOperationsErSortColumns)[number]
>;

export const getB2bOperationsErEndpoint = endpoint({
  method: 'GET',
  queryParams: ZodGetB2bOperationsErQuery,
  responseBody: ZodGetB2bOperationsErResponse,
});
export type GetB2bOperationsErEndpoint = GetEndpointType<typeof getB2bOperationsErEndpoint>;
